import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import CategoryIndexDataTable from './components/CategoryIndexDataTable';

const CategoryIndex = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Categories</h3>
          <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link></h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <CategoryIndexDataTable />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default CategoryIndex;
